import classnames from "classnames";
import PropTypes from "prop-types";
import styles from "./index.css";

const Spinner = ({ size = "small" }) => (
  <div className={classnames(styles.spinner, styles[size])}>&nbsp;</div>
);

Spinner.defaultProps = {
  size: "small"
};

Spinner.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"])
};

export default Spinner;
